import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import SectionContent from '../../../components/sectionContent/sectionContent';
import UnloadingZip from '../../../pages/unloadings/unloadingZip/unloadingZip';
import Sidebar from '../../../components/sidebar/Sidebar';

import '../../../scss/App.scss';

const AdminUnloadingZipSection: FC = () => {
	const { claims } = useSelector((state: any) => state.user.user.data);

	return (
		<div className='App'>
			<Sidebar />
			<SectionContent section='Заказанные архивы' pageName='unloadings'>
				<div className='content__main'>
					<div className='btns'>

						{claims && claims?.length > 0 && (claims.includes('admin') || claims.includes('orders:excel')) && <Link to='/unloadings/excel' className='tab'>
							<div className='buttons__btn'>Excel</div>
						</Link>}

						{claims && claims?.length > 0 && (claims.includes('admin') || claims.includes('orders:zip')) && <Link to='/unloadings/zip' className='tab'>
							<div className='buttons__btn --active'>Zip</div>
						</Link>}

						{claims && claims?.length > 0 && (claims.includes('admin') || claims.includes('payrolls:view') || claims.includes('orders:payrolls')) && (
							<Link to='/unloadings/tables' className='tab'>
								<div className='buttons__btn'>Табели</div>
							</Link>
						)}
						{(claims.includes('admin') || claims.includes('payrolls:view') || claims.includes('orders:cron')) && (
							<Link to='/unloadings/cron' className='tab'>
								<div className='buttons__btn'>Cron</div>
							</Link>
						)}
						
						{(claims.includes('admin') || claims.includes('orders:import')) && <Link to='/unloadings/template' className='tab'>
							<div className='buttons__btn'>Загрузка шаблонов</div>
						</Link>}
					</div>
					<UnloadingZip />
				</div>
			</SectionContent>
		</div>
	);
};

export default AdminUnloadingZipSection;
